import axios from 'axios'
import { Message } from 'element-ui'
import router from 'vue-router'
// import { getToken } from '@/utils/auth'
import { getUserInfo } from "@/common/utils/localStorage.js";

// let userInfo = getUserInfo
const service = axios.create({
    baseURL: process.env.ERP_API,
    // timeout: 15000
    withCredentials: true // 允许携带cookie
})

service.interceptors.request.use(config => {
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

service.interceptors.response.use(response => {
    if (response.data.code == 200 || response.data.code == 400 || response.data.code == "TTDH00") {
        return response.data
    } else {
        Message({
            message: response.data.msg,
            type: 'error',
            duration: 5 * 1000
        })
        return null
    }

}, error => {
    Message({
        message: error.msg,
        type: 'error',
        duration: 5 * 1000
    })
    return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/sealFilter/requestCtxs.js